import { registerQuery } from 'data-fetching-client';
import { getCrmSearchForFormsTotal } from 'FormsUI/api/CrmSearch';
export const GET_CRM_SEARCH_FOR_FORMS_TOTAL_FIELD_NAME = 'getCRMSearchFormsTotal';
export const GET_CRM_SEARCH_FOR_FORMS_TOTAL = registerQuery({
  fieldName: GET_CRM_SEARCH_FOR_FORMS_TOTAL_FIELD_NAME,
  args: ['objectTypeId'],
  fetcher: ({
    objectTypeId
  }) => getCrmSearchForFormsTotal({
    objectTypeId
  })
});